export default __webpack_public_path__ + "static/media/modify-1.2aedc21d.png";